export const downloadExcelTemplate = (fileName = 'customer.xlsx') => {
  const fileUrl = `/templates/${fileName}`;

  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getTemplateTitle = (code: string): string => {
  switch (code) {
    case 'TM01':
      return 'ใบส่งของ ต้นฉบับบริษัท';
    default:
      return '';
  }
};
